<template>
	<span class="shp">
			
			
			
			<b-modal id="showShareMessageModal" hide-footer body-class="bodypaddingtop">
				  <template #modal-title> Send Message</template> 
						
						<b-container fluid class="p-1">					
						<!-- {{cartItems}} -->
							<!-- p>Link<small><b-link :href="'https://www.alluraa.com/share/'+selectedLink" style="color: #5b297a;" target="_blank">https://www.alluraa.com/share/{{selectedLink}}</b-link></small></p> -->
							
							<div class="card" :key="item.id" v-for="item in selectedItemcart">
								<!-- <header class="card-header">featured</header> -->
								<div class="card-body">
									<b-row>
										<b-col cols="3" sm="3" md="3" lg="3">
											<b-link :href="'/product/'+item.product_id"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
										</b-col>
										<b-col cols="7" sm="7" md="7" lg="7">
											<span class="pTitle">{{item.title}}</span>
											<ul class="p-0 m-0 shoppopup">
												<li v-if="item.short_description!=''"><small>{{item.short_description}}</small></li>
												<li class="sharepopupStardiaplay"><product-rating :userrating="item.total_rating"></product-rating></li>
												<li ><small>Commission: </small> {{item.commission}}%</li>
												<li >
													<span v-if="item.special_price>item.price && item.special_price!=null">
													 <del class="spCross">{{$root.currency()+$root.tofixed((item.price ), 2)}}</del> <small class="my-0" >{{$root.currency()+$root.tofixed((item.special_price), 2)}}</small>
												   
													</span>
													<span v-else>
														<small class="my-0" >{{$root.currency()+$root.tofixed((item.price), 2)}}</small>
													</span>
												</li>
											</ul>
										</b-col>
										<b-col  cols="1" sm="1" md="1" lg="1">
											<b-link disabled><i class="fa fa-trash" aria-hidden="true"></i></b-link>
										</b-col>
									</b-row>
									
								</div>
								
							</div>

						
						</b-container>

				 <b-container fluid class="p-1">
				  
				 
				  <small>
				  <!-- <b-form-group label="Select Message" v-slot="{ ariaDescribedby }" class="mb-0 myoption">
				  <b-form-radio-group
					id="radio-slots"
					v-model="selected"
					:options="options"
					:aria-describedby="ariaDescribedby"
					name="radio-options-slots"				
					v-on:change="changeMessage"
				  >
				
				  </b-form-radio-group>
				</b-form-group> -->
				Message
				</small>
				
			<!--<div>Selectedd: {{selectedmess}}</div> -->
				 
				  </b-container>
				  <div class="message-textarea-wrapper">
					<b-form-textarea v-model="linkComments"
					  id="message-textarea"
					  rows="8"
					  placeholder="Type your message here"
					></b-form-textarea>
				  </div>
				  <div
					class="product-share-wrapper d-flex justify-content-center align-items-ceter mt-3">
					<!-- <span class="product-share-txt align-self-center mr-4">Share Now</span> -->
						<!-- {{selectedLink}}
						{{linkComments}} -->
							<b-row class="float-right">
								<b-col>
									<!--<div class="icon-btn float-left margin-right-half" @click="shareSelectedProducts(selectedItem, 'sms')">
										<img src="@/assets/sms.svg"/>
									</div> -->
									<!-- <b-button  v-if="$root.share.iamiconfor=='sms'" variant="dark" pill class="mr-2" @click="shareSelectedProducts(selectedItem, 'sms')">
									<img src="@/assets/sms.svg" width="20px;"/> Share Now
									</b-button> -->
									
									
										
										<b-button  v-if="$root.share.iamiconfor=='sms'" variant="dark" pill class="mr-2">
											<ShareNetwork
												network="email"
												:url="'https://www.alluraa.com/share/'+selectedLink"
												title="Alluraa Products"
												:description="linkComments"
												hashtags="Alluraa">
												<img src="@/assets/sms.svg" width="20px;" /> Share Now
											</ShareNetwork>
										</b-button>
									
									
									<b-button  v-if="$root.share.iamiconfor=='facebook'" variant="dark" pill class="mr-2"><ShareNetwork
											network="facebook"
											:url="'https://www.alluraa.com/share/'+selectedLink"
											title="Alluraa Products"
											:description="linkComments"
											hashtags="Alluraa"
											:quote="linkComments"
											>
											<img src="@/assets/facebook.svg" width="20px;"/> Send Now
										</ShareNetwork> </b-button>
									
									<b-button   v-if="$root.share.iamiconfor=='whatsapp'" variant="dark" pill class="mr-2">
										<ShareNetwork
											network="whatsapp"
											:url="'https://www.alluraa.com/'"
											title="Alluraa"
											:description="linkComments">
											<img src="@/assets/whatsapp.svg" width="20px;"/> Send Now
										</ShareNetwork>
									</b-button>
									<b-button  v-if="$root.share.iamiconfor=='twitter'" variant="dark" pill class="mr-2">
										<ShareNetwork
											network="twitter"
											:url="'https://www.alluraa.com/share/'+selectedLink"
											title="New Test Alluraa Product."
											hashtags="Alluraa,test"
											twitter-user="">
											<img src="@/assets/twitter.svg" width="20px;"/> Share Now
										</ShareNetwork>
									</b-button>
									<b-button  v-if="$root.share.iamiconfor=='telegram'" variant="dark" pill class="mr-2">
										<ShareNetwork
											network="telegram"
											url="'https://www.alluraa.com/"
											title="Alluraa."
											:description="linkComments"
											>
											<img src="@/assets/telegram.svg" width="20px;"/> Share Now
										</ShareNetwork>
									</b-button>
								</b-col>
							</b-row>
				  </div>
				</b-modal>


		</span>		
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
export default {
  name: 'SharelinkPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  },
  props: { 
	selectedItem: { type: Object},
	selectedItemcart: { type: Array},
	selectedLink:String,
	iamin:String,
  },
  mounted(){
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		linkComments:'Dear Seller,Hope you and your family members are doing great doing these unprecedented times!We request you to update your profile so that you can receive promotions and offers running on Alluraa.Having a finished profile can mean the difference between securing that perfect offer and watching it slip away. Ensure your success by completing yours now and start taking advantage of all the benefits that come from using Alluraa.Please login using your credentials and update profile for unmatched experience! Warm Regards,Team Alluraa',
		urlSavebank: this.$root.NEWAPIURL+'profileapi/save-bank',		
		thumbnailPropsPop: { blank: false, fluidGrow: true, width: 80, height: 80,class: 'm1' },
		social_options: {
            'facebook': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'instagram': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'tweeter': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'whatsapp': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'telegram': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'sms': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
        },
		selectedmess:'',
		selected: 'whatsapp',
        options: [
          { text: 'Message 1', value: 'whatsapp' },
          { text: 'Message 2', value: 'facebook' },
          { text: 'Message 3', value: 'tweeter' },
          //{ text: 'Message 4', value: 'telegram' },
         // { text: 'Message 5', value: 'instagram' }
        ],
		iamiconfor:'',
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        }

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">
		$whiteColor: #ffffff;
		$blackColor: #000000;
		$themeColor: #a059d9;
		$themeColor2: #8507d6;
		$themeColor3: #b24bf1;
		$redColor: #e61583;
		$grey: #b9b9b9;
		$grey2: #a6a6a6;
		$themeLightColor: #f2e2ff;
		$themeDarkColor: #df007e;

		@mixin setBlackBoldTextStyles() {
		  font-size: 12px;
		  color: $blackColor;
		  font-weight: bold;
		}
	
		#showShareModal {
		.modal-header{
		padding: 8px;
		}
		
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}
	#showShareMessageModal {
		.modal-header{
		padding: 8px;
		}
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}

	#message-textarea {
	  border-color: $themeDarkColor;

	  :focus {
		border-color: $themeColor2;
	  }
	}
	
	.shoppopup>li{
	line-height:15px;
	}
	
	.card{
			margin-bottom: 12px;	
			box-shadow: 0px 0px 1px 0px #c6c6c6;
			
			.card-footer{
				background-color: #fff;
				border-top: 1px solid rgba(0,0,0,.125);
				.spCross{
					    font-size: 14px;
   						color: darkgray;
				}
			}

			.card-body{
				padding: 5px;
				.pImg{
					max-height: max-content;
				}

				.pTitle{
					font-size: smaller;
					font-weight: 200;
					color: #3f414d;
				}
			}
		}
		
		#radio-slots{
		    text-align: center;
			margin-left: 3%;
		}
		.myoption{
				.custom-control{				 
					margin-right: 20px !important;
					color: #515457d1;
				}
			/*.custom-control-inline{		 
				margin-right: 50px !important;
			}*/
		}
	
	.noteMess{
			font-size: 12px;
		}
		
		.sharepopupStardiaplay{ width: 37%;height: 13px;}

</style>
